export default __webpack_public_path__ + "static/cross-border-f24a049f435f2cdd95fc1138e5f2068f.svg";